import React from "react";

const NewsPageContext = React.createContext();

export { NewsPageContext };
